import { create, show, useModal } from "@ebay/nice-modal-react";

import ConfirmationModal from "ds/components/ConfirmationModal";
import { ConfirmationModalMessage } from "ds/components/ConfirmationModal/Message";

type LoginPolicyDetailsConfirmationModalProps = {
  onConfirm: () => void;
};

const LoginPolicyDetailsConfirmationModal = create(function LoginPolicyDetailsConfirmationModal({
  onConfirm,
}: LoginPolicyDetailsConfirmationModalProps) {
  const modal = useModal();

  const handleOnConfirm = () => {
    modal.resolve();
    modal.hide();
    onConfirm();
  };

  return (
    <ConfirmationModal
      title="Save changes"
      confirmationButtonLabel="Save"
      confirmationButtonVariant="primary"
      onConfirm={handleOnConfirm}
    >
      <ConfirmationModalMessage>
        Are you sure? After changing the Login policy, all active sessions (except the current one){" "}
        <strong>will be invalidated</strong>.
      </ConfirmationModalMessage>
    </ConfirmationModal>
  );
});

export const showLoginPolicyDetailsConfirmationModal = (
  props: LoginPolicyDetailsConfirmationModalProps
) => show(LoginPolicyDetailsConfirmationModal, props);
